/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Contact data
  ============================================================

  Rakenne on tehty tulevaa WordPress REST API:a varten.

  submission.endpoint:
  - tyhjä lokaalisti = demo
  - stagingissa / tuotannossa WP REST endpoint
*/

const contactData = {
  submission: {
    endpoint: "",
    method: "POST",
  },

  events: [],

  page: {
    hero: {
      eyebrow: {
        fi: "Yhteys · Aloitetaan tästä",
        en: "Contact · Start here",
      },

      title: {
        fi: "Aloitetaan yhdestä viestistä.",
        en: "It starts with a message.",
      },

      description: {
        fi:
          "Haluatko sopia tapaamisen, ilmoittautua tapahtumaan vai kysyä jotain muuta? Valitse alta sopivin tapa.",
        en:
          "Would you like to arrange a meeting, join an event or simply get in touch? Choose the option that fits best.",
      },
    },

    heroMedia: {
      src:
        "/media/portfolio/portfolio-05.webp",

      position:
        "50% 50%",
    },
    form: {
      eyebrow: {
        fi: "01 / Yhteydenotto",
        en: "01 / Get in touch",
      },

      title: {
        fi: "Miten voin auttaa?",
        en: "How can I help?",
      },

      description: {
        fi:
          "Kaikkea ei tarvitse tietää valmiiksi. Muutama tieto riittää alkuun.",
        en:
          "You do not need to have everything figured out. A few details are enough to begin.",
      },

      required: {
        fi: "Pakollinen",
        en: "Required",
      },

      optional: {
        fi: "Vapaaehtoinen",
        en: "Optional",
      },
    },

    intents: [
      {
        id: "meeting",
        number: "01",

        title: {
          fi: "Varaa tapaaminen",
          en: "Book a meeting",
        },

        short: {
          fi: "Sovitaan aika rauhassa keskustelulle.",
          en: "Let's find a time to talk.",
        },
      },

      {
        id: "event",
        number: "02",

        title: {
          fi: "Tapahtuma",
          en: "Join an event",
        },

        short: {
          fi: "Ilmoittaudu tapahtumaan tai kysy lisätietoja.",
          en: "Register for an event or ask for details.",
        },
      },

      {
        id: "general",
        number: "03",

        title: {
          fi: "Muu yhteydenotto",
          en: "General enquiry",
        },

        short: {
          fi: "Kuvausidea, yhteistyö tai jokin muu kysymys.",
          en: "A session idea, collaboration or another question.",
        },
      },
    ],

    fields: {
      name: {
        label: {
          fi: "Nimi",
          en: "Name",
        },

        placeholder: {
          fi: "Etunimi ja sukunimi",
          en: "Your name",
        },
      },

      email: {
        label: {
          fi: "Sähköposti",
          en: "Email",
        },

        placeholder: {
          fi: "sinä@esimerkki.fi",
          en: "you@example.com",
        },
      },

      phone: {
        label: {
          fi: "Puhelin",
          en: "Phone",
        },

        placeholder: {
          fi: "Puhelinnumero",
          en: "Phone number",
        },
      },

      subject: {
        label: {
          fi: "Aihe",
          en: "Subject",
        },

        placeholder: {
          fi: "Mistä haluaisit keskustella?",
          en: "What would you like to discuss?",
        },
      },

      message: {
        label: {
          fi: "Kerro hieman lisää",
          en: "Tell me a little more",
        },

        placeholder: {
          fi:
            "Ajatus, toive tai kysymys — kirjoita juuri sen verran kuin haluat.",
          en:
            "Your idea, wish or question — share as much or as little as you like.",
        },
      },

      meetingDate: {
        label: {
          fi: "Toivottu päivä",
          en: "Preferred date",
        },
      },

      meetingTime: {
        label: {
          fi: "Sopivin ajankohta",
          en: "Preferred time",
        },

        options: [
          {
            id: "",
            label: {
              fi: "Valitse",
              en: "Choose",
            },
          },

          {
            id: "morning",
            label: {
              fi: "Aamupäivä",
              en: "Morning",
            },
          },

          {
            id: "afternoon",
            label: {
              fi: "Iltapäivä",
              en: "Afternoon",
            },
          },

          {
            id: "evening",
            label: {
              fi: "Ilta",
              en: "Evening",
            },
          },
        ],
      },

      meetingMethod: {
        label: {
          fi: "Tapaamisen tapa",
          en: "Meeting type",
        },

        options: [
          {
            id: "video",
            label: {
              fi: "Videopuhelu",
              en: "Video call",
            },
          },

          {
            id: "phone",
            label: {
              fi: "Puhelu",
              en: "Phone call",
            },
          },

          {
            id: "in-person",
            label: {
              fi: "Kasvotusten",
              en: "In person",
            },
          },
        ],
      },

      eventName: {
        label: {
          fi: "Tapahtuma",
          en: "Event",
        },

        placeholder: {
          fi: "Mihin tapahtumaan haluat osallistua?",
          en: "Which event would you like to join?",
        },
      },

      participants: {
        label: {
          fi: "Osallistujia",
          en: "Participants",
        },
      },
    },

    submit: {
      idle: {
        fi: "Lähetä viesti",
        en: "Send message",
      },

      loading: {
        fi: "Lähetetään…",
        en: "Sending…",
      },
    },

    success: {
      eyebrow: {
        fi: "Kiitos",
        en: "Thank you",
      },

      title: {
        fi: "Tästä on hyvä jatkaa.",
        en: "That's a good place to start.",
      },

      text: {
        fi:
          "Yhteydenottosi on valmis. Palaan asiaan antamiesi yhteystietojen kautta.",
        en:
          "Your enquiry is ready. I'll get back to you using the contact details you provided.",
      },

      another: {
        fi: "Lähetä toinen viesti",
        en: "Send another message",
      },

      demo: {
        fi:
          "Paikallinen demo: viestiä ei vielä lähetetä palvelimelle.",
        en:
          "Local demo: the message is not yet sent to the server.",
      },
    },

    error: {
      fi:
        "Viestin lähetys ei onnistunut. Yritä hetken kuluttua uudelleen.",
      en:
        "The message could not be sent. Please try again shortly.",
    },
  },
};

export default contactData;